module.exports = __webpack_public_path__ + "img/pocket entry.9b0619dd.png";